/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

import { AnyAction } from 'redux';
import { SET_ERROR_OSD, SET_IS_ERROR_OSD_ACTIVE } from './osd.types';

export const setIsErrorOSDActiveAction = (isErrorOSDActive: boolean): AnyAction => ({
    type: SET_IS_ERROR_OSD_ACTIVE,
    payload: {
        isErrorOSDActive,
    },
});

export const setErrorOSDAction = (
    errorCode: string,
    errorMessage: string,
    errorPriority: number,
): AnyAction => ({
    type: SET_ERROR_OSD,
    payload: {
        errorCode,
        errorMessage,
        errorPriority,
    },
});
